/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One number per line or row:
4
5
5
6
6
7`)
};

const es_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un número por línea o fila:
4
5
5
6
6
7`)
};

const de_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zahl pro Zeile oder Reihe:
4
5
5
6
6
7`)
};

const nl_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén getal per regel of rij:
4
5
5
6
6
7`)
};

const fr_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nombre par ligne ou par rangée :
4
5
5
6
6
7`)
};

const it_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un numero per riga o colonna:
4
5
5
6
6
7`)
};

const pt_br2_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um número por linha ou coluna:
4
5
5
6
6
7`)
};

const pt_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um número por linha ou fila:
4
5
5
6
6
7`)
};

const ja_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行または1マスに1つの数値:
4
5
5
6
6
7`)
};

const zh_hist_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One number per line or row:
4
5
5
6
6
7`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_placeholder", locale)
	if (locale === "en") return en_hist_placeholder(inputs)
	if (locale === "es") return es_hist_placeholder(inputs)
	if (locale === "de") return de_hist_placeholder(inputs)
	if (locale === "nl") return nl_hist_placeholder(inputs)
	if (locale === "fr") return fr_hist_placeholder(inputs)
	if (locale === "it") return it_hist_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_hist_placeholder(inputs)
	if (locale === "pt") return pt_hist_placeholder(inputs)
	if (locale === "ja") return ja_hist_placeholder(inputs)
	return zh_hist_placeholder(inputs)
};